<template>
  <div class="table-container">
    <el-table border stripe fit highlight-current-row max-height="500" :data="promotions" header-cell-class-name="table-header-cell">
      <el-table-column label="序号" width="60" align="center" type="index" fixed="left" />
      <el-table-column label="限购" width="60" align="center">
        <template slot-scope="{row}">
          <el-tag type="success" :effect="row.isLimited === 1 ? 'dark' : 'plain'">{{ row.isLimited === 1 ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="限额数量" width="80" align="center" prop="quota" />
      <el-table-column label="活动数量" width="80" align="right" prop="quantity" />
      <el-table-column label="销量" width="80" align="right" prop="volume" />
      <el-table-column label="活动价" width="80" align="right" prop="retailPrice" />
      <el-table-column label="开始日期" align="center" prop="startDate" />
      <el-table-column label="结束日期" align="center" prop="endDate" />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{row}">
          <el-tag type="success" effect="dark">{{ activityStatus[row.status] }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="80" align="center" fixed="right">
        <template slot-scope="scope">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              操作<i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="handleEdit(scope.row, scope.$index)"><i class="el-icon-edit" /> 修改</el-dropdown-item>
              <el-dropdown-item @click.native="handleDelete(scope.row, scope.$index)"><i class="el-icon-delete" /> 删除</el-dropdown-item>
              <el-dropdown-item divided :disabled="scope.row.status > 0" @click.native="handleStart(scope.row)"><i class="el-icon-check" /> 马上开始</el-dropdown-item>
              <el-dropdown-item :disabled="scope.row.status == 2" @click.native="handleFinish(scope.row)"><i class="el-icon-close" /> 结束活动</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { updatePromotionStatus, removePromotion } from '@/api/goods'
export default {
  name: 'PromoTable',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      activityStatus: ['未开始', '进行中', '已结束']
    }
  },
  computed: {
    promotions: {
      get() {
        return this.list
      },
      set(val) {
        this.$emit('update:list', val)
      }
    }
  },
  methods: {
    handleEdit(item, index) {
      this.$emit('edit', {
        value: this.$util.deepClone(item),
        index
      })
    },
    handleDelete(item, index) {
      this.$confirm('确认要删除该活动吗？', '温馨提示', { type: 'warning' }).then(() => {
        if (item.id && item.goodsId) {
          removePromotion(item).then(response => {
            this.promotions = response
          }).catch(() => {})
        } else {
          this.promotions.splice(index, 1)
        }
      }).catch(() => {})
    },
    handleStart(item) {
      this.$confirm('确认要马上开始该活动吗？', '温馨提示', { type: 'warning' }).then(() => {
        const promotion = this.$util.deepClone(item)
        promotion.status = 1
        return updatePromotionStatus(promotion)
      }).then(response => {
        if (response) item.status = 1
      }).catch(() => {})
    },
    handleFinish(item) {
      this.$confirm('确认要结束该活动吗？', '温馨提示', { type: 'warning' }).then(() => {
        const promotion = this.$util.deepClone(item)
        promotion.status = 2
        return updatePromotionStatus(promotion)
      }).then(response => {
        if (response) item.status = 2
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.table-container {
  margin-bottom: 20px;
  width: 100%;

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    .el-icon-arrow-down {
      font-size: 12px;
    }
  }
}
</style>
